// extracted by mini-css-extract-plugin
export default {"top":"nwNT4","header":"M5Zj9","aside":"egopN"};